import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 60%;
    margin: 0 auto;
`;
